import { render, staticRenderFns } from "./BackmenuList.vue?vue&type=template&id=033dedec&"
import script from "./BackmenuList.vue?vue&type=script&lang=js&"
export * from "./BackmenuList.vue?vue&type=script&lang=js&"
import style0 from "./BackmenuList.vue?vue&type=style&index=0&scope=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports